module.exports = __webpack_public_path__ + "static/img/dianli.e5d8483b.svg";